// Convert Underscores To Hyphens
export const convertUnderscoresToHyphens = (input: string) => {
  if (input.includes("_")) {
    return input.replace(/_/g, "-");
  }
  return input;
};

// Get the first path segment
export const getFirstPathSegment = (location: string) => {
  const path = location.split("/").filter(Boolean)[0] || "";
  return path;
};
